;(function () {
  if (window.__iwtFloatingOverlayDestroy) {
    window.__iwtFloatingOverlayDestroy()
  }

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value))
  const sliderInstances = new Map()
  const motionState = new WeakMap()
  let rafId = 0

  const getState = (target) => {
    return motionState.get(target) || {
      currentX: 0,
      currentY: 0
    }
  }

  const setState = (target, state) => {
    motionState.set(target, state)
  }

  const isMotionEnabled = (element) =>
    element && String(element.dataset.floatEnabled).toLowerCase() === 'true'

  const getDesktopAmp = (element) => Number(element.dataset.floatDesktop || 10)
  const getMobileAmp = (element) => Number(element.dataset.floatMobile || 8)

  const applyMotion = (element, x, y) => {
    element.style.setProperty('--overlay-move-x', `${x}px`)
    element.style.setProperty('--overlay-move-y', `${y}px`)
  }

  const getSliderHost = (node) => {
    return node
      ? node.closest('[data-iwt-slider-host], .image-with-text__media--slider')
      : null
  }

  const getSliderReferenceBox = (host) => {
    if (!host) return null

    return (
      host.querySelector('.image-with-text__media-inner--slider') ||
      host.querySelector('.image-with-text__media-inner') ||
      host
    )
  }

  const getActiveSlideNumber = (host) => host.getAttribute('data-iwt-active-slide') || '1'

  const getSliderOverlays = (host) => {
    return Array.from(
      host.querySelectorAll('[data-iwt-floating].image-with-text__floating--slide')
    ).filter(isMotionEnabled)
  }

  const getVisibleSliderOverlay = (host, overlays) => {
    const activeSlide = getActiveSlideNumber(host)

    return (
      overlays.find((overlay) =>
        overlay.classList.contains(`image-with-text__floating--slide-${activeSlide}`)
      ) ||
      overlays.find((overlay) => {
        const styles = window.getComputedStyle(overlay)
        return styles.visibility !== 'hidden' && styles.opacity !== '0'
      }) ||
      overlays[0]
    )
  }

  const setActiveSlide = (swiper, host) => {
    if (!host) return
    const activeIndex = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex || 0
    host.setAttribute('data-iwt-active-slide', String(activeIndex + 1))
  }

  const initSliders = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document

    scope.querySelectorAll('[data-iwt-slider]').forEach((slider) => {
      if (sliderInstances.has(slider)) return
      if (typeof Swiper === 'undefined') return

const host = getSliderHost(slider)
      const pagination = host ? host.querySelector('.image-with-text__pagination') : null
      if (!host || !pagination) return

const isAutoplay = slider.dataset.iwtAutoplay === 'true' || slider.getAttribute('data-iwt-autoplay') === 'true'
      const autoplayDelay = parseInt(slider.dataset.iwtAutoplayDelay, 10) || 4000
      
      const swiperOptions = {
        loop: false, 
        speed: 800,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets', // <-- Changed from custom to bullets to guarantee clickability
          renderBullet: function (index, className) {
            return `<span class="${className}" tabindex="0" role="button" aria-label="Go to slide ${index + 1}"></span>`
          }
        },
        on: {
          init(swiper) { setActiveSlide(swiper, host) },
          slideChange(swiper) { setActiveSlide(swiper, host) },
          slideChangeTransitionEnd(swiper) { setActiveSlide(swiper, host) }
        }
      }

      const instance = new Swiper(slider, swiperOptions)

      // --- SMART BULLETPROOF AUTOPLAY ---
      if (isAutoplay) {
        const startAutoplay = () => {
          clearInterval(slider.iwtAutoplayTimer);
          slider.iwtAutoplayTimer = setInterval(() => {
            if (instance && !instance.destroyed) {
              if (instance.isEnd) {
                instance.slideTo(0); // Rewind
              } else {
                instance.slideNext(); // Advance
              }
            }
          }, autoplayDelay);
        };

        // Start it initially
        startAutoplay();

        // Pause the timer if the user is touching/dragging the image
        instance.on('touchStart', () => clearInterval(slider.iwtAutoplayTimer));
        
        // Restart the timer when they let go, or if they click a bullet
        instance.on('touchEnd', startAutoplay);
        instance.on('slideChange', startAutoplay); 
      }

      sliderInstances.set(slider, instance)
    })
  }

  let pointerTargetX = window.innerWidth * 0.5
  let pointerTargetY = window.innerHeight * 0.5
  let pointerX = pointerTargetX
  let pointerY = pointerTargetY
  let lastMouseMoveAt = 0

  const updatePointer = (event) => {
    if (typeof event.clientX !== 'number' || typeof event.clientY !== 'number') return

    pointerTargetX = event.clientX
    pointerTargetY = event.clientY

    if (event.type === 'mousemove' || event.pointerType === 'mouse') {
      lastMouseMoveAt = window.performance.now()
    }
  }

  const hasFinePointer = () => window.matchMedia('(pointer: fine)').matches
  const hasRecentMouseInput = () => window.performance.now() - lastMouseMoveAt < 500

  const animateTarget = ({
    stateTarget,
    referenceBox,
    desktopAmp,
    mobileAmp,
    useScrollMotion,
    viewportWidth,
    viewportHeight
  }) => {
    const state = getState(stateTarget)

    let targetX = 0
    let targetY = 0

    if (useScrollMotion) {
      const rect = referenceBox.getBoundingClientRect()
      const viewportCenter = viewportHeight * 0.5
      const rectCenter = rect.top + rect.height * 0.5
      const progress = clamp((viewportCenter - rectCenter) / (viewportHeight * 0.5), -1, 1)

      targetX = 0
      targetY = progress * mobileAmp
    } else {
      const normalizedX = clamp((pointerX / viewportWidth - 0.5) * 2, -1, 1)
      const normalizedY = clamp((pointerY / viewportHeight - 0.5) * 2, -1, 1)

      targetX = normalizedX * desktopAmp * 0.45
      targetY = normalizedY * desktopAmp * 0.45
    }

    state.currentX += (targetX - state.currentX) * 0.12
    state.currentY += (targetY - state.currentY) * 0.12

    const x = Number(state.currentX.toFixed(1))
    const y = Number(state.currentY.toFixed(1))

    setState(stateTarget, state)

    return { x, y }
  }

const animate = () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches
    const viewportWidth = Math.max(window.innerWidth, 1)
    const viewportHeight = Math.max(window.innerHeight, 1)
    const isPointerFine = hasFinePointer()

    pointerX += (pointerTargetX - pointerX) * 0.18
    pointerY += (pointerTargetY - pointerY) * 0.18

    const useScrollMotion =
      isMobile ||
      (!isPointerFine && !hasRecentMouseInput())

    document.querySelectorAll('[data-iwt-floating]').forEach((element) => {
      if (!isMotionEnabled(element)) return

      // Get the parent slider container ONLY to use for accurate scroll measurements.
      // If it's not a slider, it just safely falls back to the element itself.
      const sliderHost = getSliderHost(element)
      const referenceBox = getSliderReferenceBox(sliderHost) || element

      const motion = animateTarget({
        stateTarget: element, // <-- The key fix: Every overlay owns its own independent physics state.
        referenceBox: referenceBox,
        desktopAmp: getDesktopAmp(element),
        mobileAmp: getMobileAmp(element),
        useScrollMotion,
        viewportWidth,
        viewportHeight
      })

      // Force the CSS update directly to the element
      applyMotion(element, motion.x, motion.y)
    })

    rafId = window.requestAnimationFrame(animate)
  }

const initWordReveal = (root = document) => {
    /* Removed the 750px block so the observer runs reliably in the Theme Editor & on window resize! */
    const scope = root && root.querySelectorAll ? root : document;
    const containers = scope.querySelectorAll('[data-mobile-word-reveal]:not(.is-initialized)');
    
    if (!containers.length) return;
    // Set up the intersection observer to watch when paragraphs scroll into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible'); 
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -25% 0px', // Increased to -25%: user must scroll further down before it triggers
      threshold: 0.1
    });

    containers.forEach(container => {
      container.classList.add('is-initialized');
      
      const blocks = Array.from(container.children);
      blocks.forEach(block => {
        observer.observe(block);
      });
    });
  };

  const onSectionLoad = (event) => {
    const root = event && event.target ? event.target : document
    initSliders(root)
    initWordReveal(root)
  }

  const onSectionUnload = (event) => {
    const root = event && event.target ? event.target : document

    root.querySelectorAll('[data-iwt-slider]').forEach((slider) => {
      const instance = sliderInstances.get(slider)

      if (instance && typeof instance.destroy === 'function') {
        instance.destroy(true, true)
      }

      sliderInstances.delete(slider)
    })
  }

const start = () => {
    initSliders(document)
    initWordReveal(document)

    if (!rafId) {
      rafId = window.requestAnimationFrame(animate)
    }
  }

  const destroy = () => {
    if (rafId) {
      window.cancelAnimationFrame(rafId)
      rafId = 0
    }

    sliderInstances.forEach((instance) => {
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy(true, true)
      }
    })
    sliderInstances.clear()

    window.removeEventListener('pointermove', updatePointer)
    window.removeEventListener('mousemove', updatePointer)
    document.removeEventListener('shopify:section:load', onSectionLoad)
    document.removeEventListener('shopify:section:unload', onSectionUnload)
  }

  window.__iwtFloatingOverlayDestroy = destroy

  window.addEventListener('pointermove', updatePointer, { passive: true })
  window.addEventListener('mousemove', updatePointer, { passive: true })
  document.addEventListener('shopify:section:load', onSectionLoad)
  document.addEventListener('shopify:section:unload', onSectionUnload)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
})()
